import * as Sentry from '@sentry/react';

import { createCustomErrorWithOriginal, logException } from '@hcs/utils';

const SentryLoggingError = createCustomErrorWithOriginal('SentryLoggingError');

export const sentryLogging = {
  logInfo: (message: string, attributes?: Record<string, unknown>) => {
    try {
      Sentry.logger.info(message, attributes);
    } catch (e) {
      logException(new SentryLoggingError('Sentry.logger.info failed', e));
    }
  },
  logDebug: (message: string, attributes?: Record<string, unknown>) => {
    try {
      Sentry.logger.debug(message, attributes);
    } catch (e) {
      logException(new SentryLoggingError('Sentry.logger.debug failed', e));
    }
  },
  logWarn: (message: string, attributes?: Record<string, unknown>) => {
    try {
      Sentry.logger.warn(message, attributes);
    } catch (e) {
      logException(new SentryLoggingError('Sentry.logger.warn failed', e));
    }
  },
  logError: (message: string, attributes?: Record<string, unknown>) => {
    try {
      Sentry.logger.error(message, attributes);
    } catch (e) {
      logException(new SentryLoggingError('Sentry.logger.error failed', e));
    }
  },
};
